import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { QuizQuestion } from '../models';
import { PaginationParams } from '../types';

export const quizQuestionsActions = createActionGroup({
    source: 'QuizQuestions',
    events: {
        'Get Quiz Questions': props<{ value: PaginationParams }>(),
        'Get Quiz Questions Success': props<{ payload: QuizQuestion[]; total: number }>(),
        'Get Quiz Questions Error': props<{ code: number }>(),
        Clear: emptyProps(),
    },
});
